import { useCreateTheme } from '@/api/glow-up/glow-up.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { CreateThemeRequest } from '@repo/types/src/glow-up';
import { CirclePlus } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

export const AddTheme = ({ refetch }: { refetch: () => void }) => {
  const mutation = useCreateTheme();
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
  });

  const handleCreate = () => {
    if (!formData.title || !formData.description) {
      toast.error('Veuillez remplir tous les champs obligatoires');
      return;
    }

    const payload: CreateThemeRequest = {
      title: formData.title,
      description: formData.description,
    };

    mutation.mutate(payload, {
      onSuccess: (data) => {
        setOpen(false);
        setFormData({ title: '', description: '' });
        refetch();
        toast.success(`Le thème ${data.title} a été créé avec succès!`, {
          duration: 3000,
        });
      },
      onError: () => {
        toast.error(`Erreur lors de la création du thème ${payload.title}`, {
          duration: 3000,
        });
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <Button>
          <div className="flex flex-row gap-2 items-center">
            <CirclePlus size={24} />
            <span>Ajouter un thème</span>
          </div>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">Ajouter un thème</DialogTitle>
          <DialogDescription className="text-center">
            Créer un nouveau thème pour les exercices
          </DialogDescription>
        </DialogHeader>

        <div className="w-full flex flex-col space-y-4">
          <div>
            <Input
              type="text"
              placeholder="Titre du thème"
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
            />
          </div>

          <div>
            <Input
              type="text"
              placeholder="Description du thème"
              value={formData.description}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
            />
          </div>
        </div>

        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost">Annuler</Button>
          </DialogClose>
          <Button variant="default" onClick={handleCreate}>
            Ajouter
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
